import { Box, Text } from "@chakra-ui/react";
import Select from "react-select";
import SelectedProducts from "./SelectedProducts";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { warehouseAction } from "../../../../store/actions/warehouseAction";

export default function DcInfoFields({ defaultSelectedProducts, receivingDC, setReceivingDC, setReceivedProducts, isViewOnly, defaultDc }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(warehouseAction());
  }, []);

  const { warehouses } = useSelector((state) => state.warehouse);
  const dcList = warehouses?.map?.(warehouse => ({ ...warehouse, label: warehouse.warehouseName, value: warehouse.id })) || [];

  useEffect(() => {
    if (!!warehouses.length) {
      setReceivingDC(dcList.find(dc => defaultDc.warehouseId === dc.id));
    }
  }, [warehouses]);

  return (
    <>
      <Box>
        <Text fontWeight={"700"} className="action-content">
          Receiving DC:
        </Text>
        <Select
          className="basic-single"
          classNamePrefix="select"
          value={receivingDC}
          isClearable={false}
          isSearchable
          isDisabled={isViewOnly || !dcList.length}
          name="receivingDC"
          options={dcList}
          placeholder="Select DC"
          components={{
            IndicatorSeparator: () => null
          }}
          styles={{
            control: (baseStyles) => {
              return {
                ...baseStyles,
                opacity: 1,
                borderColor: "inherit !important",
              };
            },
          }}
          onChange={(event) => {
            setReceivingDC(event);
          }}
        />
      </Box>
      <Box marginTop="24px" paddingTop="12px" borderTop="1px solid #E2E8F0">
        <Text fontWeight={"700"} className="action-content" fontSize="16px">
          Product Received by DC
        </Text>
        <Box>
          <SelectedProducts defaultSelectedProducts={defaultSelectedProducts} setReceivedProducts={setReceivedProducts} isViewOnly={isViewOnly} />
        </Box>
      </Box>
    </>
  );
}
